import { Grid, Radio, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { editRMTableData } from '../../../../../containers/actions/common/saslAction';
import { useStyles } from '../styles';
import AvailabilityTable from './AvailabilityTable';

const RMSection = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { initialRM, rmAvailability, handleRMChange, rmTableData, batchCount } =
    props;

  const handleRMDataChange = (value) => {
    if (rmAvailability === 'no') {
      dispatch(editRMTableData(value));
    }
  };

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        // className={classes.paddingBottom}
      >
        <Typography variant='body2' className={classes.title}>
          Raw Material Availability
        </Typography>
        <span className={classes.span}></span>
      </Grid>
      {localStorage.collabType !== 'Pharma Co' && initialRM ? (
        <Grid container>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            lg={6}
            // className={classes.sidePadding}
          >
            <Typography
              variant='body2'
              className={classes.font}
              style={{ paddingRight: '10rem' }}
            >
              Is the required quantity of raw materials (APIs & Excipients)
              available for this line item?
            </Typography>
          </Grid>

          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            lg={6}
            // className={classes.sidePadding}
          >
            <Radio
              className={classes.radio}
              checked={rmAvailability === 'yes'}
              onChange={handleRMChange}
              value='yes'
              name='rm-radio-button'
            />
            <span style={{ fontWeight: 500, paddingRight: '3rem' }}>Yes</span>
            <Radio
              className={classes.radio}
              checked={rmAvailability === 'no'}
              onChange={handleRMChange}
              value='no'
              name='rm-radio-button'
            />
            <span style={{ fontWeight: 500 }}>No</span>
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            lg={6}
            className={classes.sidePadding}
          >
            <Typography variant='caption' color='primary'>
              Note: Click "No" to update the availability status
            </Typography>
          </Grid>
          {rmAvailability && (
            <AvailabilityTable
              batchCount={batchCount}
              data={rmTableData}
              handleDataChange={handleRMDataChange}
              availability={rmAvailability}
            />
          )}
        </Grid>
      ) : initialRM ? (
        <Grid container>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            lg={6}
            className={classes.sidePadding}
          >
            <Typography
              variant='body2'
              className={classes.font}
              style={{ paddingRight: '10rem' }}
            >
              RM/PM Availability status has not been updated yet.
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <AvailabilityTable
          batchCount={batchCount}
          data={rmTableData}
          handleDataChange={handleRMDataChange}
          availability={rmAvailability}
        />
      )}
    </React.Fragment>
  );
};

export default RMSection;
